<script setup lang="ts">
import AppsLink from './AppsLink.vue';
import { Icon } from '@iconify/vue';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
</script>

<template>
  <v-menu
    open-on-hover
    open-on-click
  >
    <template #activator="{ props }">
      <v-btn
        icon
        class="custom-hover-primary"
        size="small"
        variant="text"
        color="primary"
        v-bind="props"
      >
        <Icon
          icon="solar:widget-line-duotone"
          height="22"
        />
      </v-btn>
    </template>
    <v-sheet
      rounded="md"
      width="360"
      elevation="10"
    >
      <PerfectScrollbar style="height: 370px">
        <div class="pa-6">
          <AppsLink />
        </div>
      </PerfectScrollbar>
    </v-sheet>
  </v-menu>
</template>

<style scoped lang="scss">
.custom-hover-primary {
  &:hover {
    background-color: rgb(var(--v-theme-lightprimary));
    color: rgb(var(--v-theme-primary));
  }
}
</style>
